export default "/assets/images/app-showcase-01-sm.jpg?777e8238519f6d5234bfbc461480765f";